import React from 'react';

const EAN = () => {
    return <img src={`/images/ean-code-example.png`} alt={"штрих-код"} style={{margin: 10, height: 45}}/>
}

export default EAN;
